import styled from 'react-emotion';

export const Err = styled.div`
	display: block;
	margin: 1.8rem 3.1rem 1.8rem 0;
	color: red;
	font-size: 1.4rem;
	font-weight: 400;
	text-align: center;
`
